import { GetTabIndex, GetTabProducts, ChangeTab } from "./toplist";

export default function toplistJs() {
  $(function () {
    if ($("#toplist-page").length > 0) {
      $(".tabs-nav li:eq(" + GetTabIndex() + ")").addClass("active");
      GetTabProducts();
    }

    $('.nav-drop-item-func').on('click', function (e) {
      let target = e.target;
      if ($(target).parent().hasClass('nav-drop-item-func')) {
        ChangeTab($(target).parent());
      } else {
        ChangeTab($(target));
      }
    })
  });
}